export default "__VITE_ASSET__Brlulh4z__"